// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae365708","453":"0b617919","455":"0c157a8d","977":"1dad2f29"}[chunkId] + ".chunk.js";
};